module.exports = __webpack_public_path__ + "static/media/dashboard-marketplace-banner-icon.9d82a9c1.svg";